"use strict";
var _a;
exports.__esModule = true;
exports.sliceMapper = void 0;
var anchor_list_slice_1 = require("./anchor-list-slice");
var article_list_slice_1 = require("./article-list-slice");
var banner_cta_slice_1 = require("./banner-cta-slice");
var bulle_talk_slice_1 = require("./bulle-talk-slice");
var card_list_slice_1 = require("./card-list-slice");
var cta_slice_1 = require("./cta-slice");
var download_links_slice_1 = require("./download-links-slice");
var exergue_slice_1 = require("./exergue-slice");
var footnotes_slice_1 = require("./footnotes-slice");
var heading2_slice_1 = require("./heading2-slice");
var headnote_slice_1 = require("./headnote-slice");
var hub_slice_1 = require("./hub-slice");
var image_slice_1 = require("./image-slice");
var insert_slice_1 = require("./insert-slice");
var interview_slice_1 = require("./interview-slice");
var key_numbers_slice_1 = require("./key-numbers-slice");
var large_card_grid_slice_1 = require("./large-card-grid-slice");
var list_slice_1 = require("./list-slice");
var podcast_slice_1 = require("./podcast-slice");
var press_release_list_slice_1 = require("./press-release-list-slice");
var profile_list_slice_1 = require("./profile-list-slice");
var profile_slice_1 = require("./profile-slice");
var publication_list_slice_1 = require("./publication-list-slice");
var quote_slice_1 = require("./quote-slice");
var related_articles_slice_1 = require("./related-articles-slice");
var sizeable_heading2_slice_1 = require("./sizeable-heading2-slice");
var slider_hero_slice_1 = require("./slider-hero-slice");
var text_slice_1 = require("./text-slice");
var text_with_bulle_talk_slice_1 = require("./text-with-bulle-talk-slice");
var text_with_image_slice_1 = require("./text-with-image-slice");
var text_with_profile_slice_1 = require("./text-with-profile-slice");
var tile_grid_slice_1 = require("./tile-grid-slice");
var twitter_carousel_slice_1 = require("./twitter-carousel-slice");
var verbatim_slice_1 = require("./verbatim-slice");
var video_hero_slice_1 = require("./video-hero-slice");
var video_slice_1 = require("./video-slice");
var PrismicSliceType;
(function (PrismicSliceType) {
    PrismicSliceType["AnchorList"] = "anchor_list";
    PrismicSliceType["ArticleList"] = "article_list";
    PrismicSliceType["BannerCta"] = "banner_cta";
    PrismicSliceType["BulleTalk"] = "bulle_talk";
    PrismicSliceType["CardList"] = "card_list";
    PrismicSliceType["Cta"] = "cta";
    PrismicSliceType["DownloadLinks"] = "download_links";
    PrismicSliceType["Exergue"] = "exergue";
    PrismicSliceType["Footnotes"] = "footnotes";
    PrismicSliceType["Heading2"] = "heading_2";
    PrismicSliceType["Headnote"] = "headnote";
    PrismicSliceType["Hub"] = "hub";
    PrismicSliceType["Image"] = "image";
    PrismicSliceType["Insert"] = "insert";
    PrismicSliceType["Interview"] = "interview";
    PrismicSliceType["KeyNumbers"] = "key_numbers";
    PrismicSliceType["LargeCardGrid"] = "large_card_grid";
    PrismicSliceType["List"] = "list";
    PrismicSliceType["Podcast"] = "podcast";
    PrismicSliceType["PressReleaseList"] = "press_release_list";
    PrismicSliceType["Profile"] = "profile";
    PrismicSliceType["ProfileList"] = "profile_list";
    PrismicSliceType["PublicationList"] = "publication_list";
    PrismicSliceType["Quote"] = "quote";
    PrismicSliceType["RelatedArticles"] = "related_articles";
    PrismicSliceType["SizeableHeading2"] = "sizeable_heading_2";
    PrismicSliceType["SliderHero"] = "slider_hero";
    PrismicSliceType["Text"] = "text";
    PrismicSliceType["TextWithImage"] = "text_with_image";
    PrismicSliceType["TextWithProfile"] = "text_with_profile";
    PrismicSliceType["TextWithBulleTalk"] = "text_with_bulle_talk";
    PrismicSliceType["TileGrid"] = "tile_grid";
    PrismicSliceType["TwitterCarousel"] = "twitter_carousel";
    PrismicSliceType["Verbatim"] = "verbatim";
    PrismicSliceType["Video"] = "video";
    PrismicSliceType["VideoHero"] = "video_hero";
})(PrismicSliceType || (PrismicSliceType = {}));
exports.sliceMapper = (_a = {},
    _a[PrismicSliceType.AnchorList] = anchor_list_slice_1.toAnchorListSlice,
    _a[PrismicSliceType.ArticleList] = article_list_slice_1.toArticleListSlice,
    _a[PrismicSliceType.BannerCta] = banner_cta_slice_1.toBannerCtaSlice,
    _a[PrismicSliceType.BulleTalk] = bulle_talk_slice_1.toBulleTalkSlice,
    _a[PrismicSliceType.CardList] = card_list_slice_1.toCardListSlice,
    _a[PrismicSliceType.Cta] = cta_slice_1.toCTASlice,
    _a[PrismicSliceType.DownloadLinks] = download_links_slice_1.toDownloadLinksSlice,
    _a[PrismicSliceType.Exergue] = exergue_slice_1.toExergueSlice,
    _a[PrismicSliceType.Footnotes] = footnotes_slice_1.toFootnotesSlice,
    _a[PrismicSliceType.Heading2] = heading2_slice_1.toHeading2Slice,
    _a[PrismicSliceType.Headnote] = headnote_slice_1.toHeadnoteSlice,
    _a[PrismicSliceType.Hub] = hub_slice_1.toHubSlice,
    _a[PrismicSliceType.Image] = image_slice_1.toImageSlice,
    _a[PrismicSliceType.Insert] = insert_slice_1.toInsertSlice,
    _a[PrismicSliceType.Interview] = interview_slice_1.toInterviewSlice,
    _a[PrismicSliceType.KeyNumbers] = key_numbers_slice_1.toKeynumbersSlice,
    _a[PrismicSliceType.List] = list_slice_1.toListSlice,
    _a[PrismicSliceType.LargeCardGrid] = large_card_grid_slice_1.toLargeCardGridSlice,
    _a[PrismicSliceType.Podcast] = podcast_slice_1.toPodcastSlice,
    _a[PrismicSliceType.PressReleaseList] = press_release_list_slice_1.toPressReleaseListSlice,
    _a[PrismicSliceType.Profile] = profile_slice_1.toProfileSlice,
    _a[PrismicSliceType.ProfileList] = profile_list_slice_1.toProfileListSlice,
    _a[PrismicSliceType.PublicationList] = publication_list_slice_1.toPublicationListSlice,
    _a[PrismicSliceType.Quote] = quote_slice_1.toQuoteSlice,
    _a[PrismicSliceType.RelatedArticles] = related_articles_slice_1.toRelatedArticlesSlice,
    _a[PrismicSliceType.SizeableHeading2] = sizeable_heading2_slice_1.toSizeableHeading2Slice,
    _a[PrismicSliceType.SliderHero] = slider_hero_slice_1.toSliderHeroSlice,
    _a[PrismicSliceType.Text] = text_slice_1.toTextSlice,
    _a[PrismicSliceType.TextWithImage] = text_with_image_slice_1.toTextWithImageSlice,
    _a[PrismicSliceType.TextWithProfile] = text_with_profile_slice_1.toTextWithProfileSlice,
    _a[PrismicSliceType.TextWithBulleTalk] = text_with_bulle_talk_slice_1.toTextWithBulleTalkSlice,
    _a[PrismicSliceType.TileGrid] = tile_grid_slice_1.toTileGridSlice,
    _a[PrismicSliceType.TwitterCarousel] = twitter_carousel_slice_1.toTwitterCarouselSlice,
    _a[PrismicSliceType.Verbatim] = verbatim_slice_1.toVerbatimSlice,
    _a[PrismicSliceType.Video] = video_slice_1.toVideoSlice,
    _a[PrismicSliceType.VideoHero] = video_hero_slice_1.toVideoHeroSlice,
    _a);
//# sourceMappingURL=slice-mapper.js.map